import { CONSOLIDATION_STATE_RESOURCE_TYPE } from '@jira/router-resources__eoc-tenant-info/src/consolidationStateResourceType.constants.tsx';
import type { TenantInfo } from '@jira/router-resources__eoc-tenant-info/src/TenantInfo.types.tsx';
import { checkShouldUseJSM } from '@jira/eoc__tenant-info/src/controllers/utils.tsx';
import type { RouteResourceResponse } from '@atlassian/react-resource-router';

// Redefined here since it is not exported from RRR.
type ResourceDependencies = {
	[type: string]: RouteResourceResponse;
};

export const checkConsolidationOnRouteDependency = (
	dependencies: ResourceDependencies,
): boolean => {
	const { data } = dependencies[CONSOLIDATION_STATE_RESOURCE_TYPE];
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return checkShouldUseJSM(data as TenantInfo | null);
};
